import { Component } from '@angular/core';
import { DataLayerService } from 'src/app/services/dataLayer/datalayer.service';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';

@Component({
    selector: 'app-faqs',
    templateUrl: './faqs.component.html',
    styleUrls: ['./faqs.component.scss'],
    imports: [MatFormField, MatIcon, MatSuffix, MatInput, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle]
})
export class FaqsComponent {
  expandQues:string = 'expand';
  collapseQues:string = 'collapse';

  constructor(private _DataLayerService:DataLayerService){

  }


  onExpand(question:string) {
    this._DataLayerService.open_close_click_faq(question)
  }
  
  onCollapse(question:string) {
    this._DataLayerService.open_close_click_faq(question)
  }

}
